// filepath: c:\Users\evict\Desktop\SpellgatherV2\web\src\components\GlobalErrorBoundary.tsx
import React, { ErrorInfo } from "react";

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

class GlobalErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    console.warn("[GlobalErrorBoundary] Caught error:", error, info);
    if (typeof window !== "undefined") {
      if (
        window.location.pathname !== "/UnderConstruction" &&
        !sessionStorage.getItem("__redirected_construction")
      ) {
        sessionStorage.setItem("__redirected_construction", "1");
        setTimeout(() => {
          window.location.assign("/UnderConstruction");
        }, 10);
      }
    }
  }

  render() {
    // Render children so redirect can occur (we already set hasError)
    return this.props.children;
  }
}

export { GlobalErrorBoundary };
export default GlobalErrorBoundary;
